import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es en papel o digital?',
  a: 'Es un producto 100% digital en formato PDF de alta resolución. Lo recibís de forma inmediata en tu correo electrónico y podés imprimirlo en casa o en cualquier centro de copiado las veces que necesites.'
}, {
  q: '¿Tengo que estar al lado de mi hijo todo el tiempo?',
  a: 'No. El material está diseñado para que el niño pueda avanzar de forma autónoma. Tu rol es presentar la misión del día y validar el logro al final. No necesitás conocimientos pedagógicos ni ser docente.'
}, {
  q: '¿Para qué edad está pensado exactamente?',
  a: 'Para niños que estén cursando 5to grado de primaria o que vayan a ingresar a 5to en el próximo ciclo escolar. También funciona muy bien para chicos de 4to avanzado que quieran llegar fortalecidos al próximo año.'
}, {
  q: '¿Qué pasa si mi hijo no quiere hacerlo?',
  a: 'Para eso está el Bono 3: Frases que Motivan sin Presionar. Te damos los scripts exactos para manejar la resistencia sin conflictos. La mayoría de los chicos se enganchan rápido cuando entienden que es una misión y no una tarea.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'De forma inmediata. Apenas completás el pago recibís un correo con el enlace de descarga. En menos de 5 minutos tenés todo en tu dispositivo listo para usar.'
}, {
  q: '¿Sirve si mi hijo tiene dificultades de aprendizaje?',
  a: 'Sí. El material está diseñado con actividades progresivas y claras. Si tu hijo tiene necesidades educativas especiales, el Bono 1 te ayuda a adaptar el ritmo y la presentación de cada misión.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-20 bg-transparent" data-id="element-33">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-34">
        <div className="text-center mb-10 md:mb-12" data-id="element-35">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#7d8a6e] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-36">
            Preguntas Frecuentes
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#2f3a2c] leading-tight" data-id="element-37">
            Respondemos a{' '}
            <em className="text-[#c06a52] not-italic font-bold italic" data-id="element-38">
              tus preguntas
            </em>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-2xl shadow-sm shadow-black/5" data-id="element-40">
                <button className="w-full px-6 md:px-8 py-5 md:py-6 text-left flex justify-between items-center gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-41">
                  <span className="font-heading font-bold text-[#2f3a2c] text-lg md:text-xl" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className="flex-shrink-0 w-9 h-9 rounded-full bg-[#7d8a6e] text-white flex items-center justify-center transition-colors" aria-hidden="true" data-id="element-43">
                    {isOpen ? <Minus className="w-4 h-4" data-id="element-44" /> : <Plus className="w-4 h-4" data-id="element-45" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-46">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-47">
                      <div className="px-6 md:px-8 pb-6 md:pb-7 -mt-1 text-slate-600 leading-relaxed text-[15px] md:text-base max-w-[58ch]" data-id="element-48">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}